// extracted by mini-css-extract-plugin
export var section = "Modules-module--section--xZ3t1";
export var content = "Modules-module--content--W9GtD";
export var column = "Modules-module--column--tMsAk";
export var title_container = "Modules-module--title_container--+imji";
export var buttons = "Modules-module--buttons--6INlK";
export var arrow = "Modules-module--arrow--46FvG";
export var products_block = "Modules-module--products_block--d-7oz";
export var is_mobile = "Modules-module--is_mobile--uvaCr";
export var is_desktop = "Modules-module--is_desktop--7RGpi";